import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { tamanioGrafica } from "utils/generalFunctions";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarchartComparativa = ({ dataGrafica }) => {
  const [datos, setDatos] = useState([]);
  const [labelsGrafica, setLabelsGrafica] = useState(["s", "d", "d", "d"]);
  const [maxYGrafica, setmaxYGrafica] = useState(0);
  const [datosGrafica, setDatosGrafica] = useState([]);

  useEffect(() => {
    setDatos(dataGrafica);
  }, [dataGrafica]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
      },
    },

    scales: {
      y: {
        min: 0,
        max: maxYGrafica,
      },
      x: {
        ticks: { color: "rgb(255, 99, 132)" },
      },
    },
  };

  useEffect(() => {
    let labelsHoras = [];
    let datosGrafica = [];

    //Rellenar la gráfica independientemente si lo que me llega son inversores o instalaciones
    datos?.forEach((dato) => {
      labelsHoras.push(dato.dato);
      datosGrafica.push(dato.potencia);
    });

    setLabelsGrafica([...labelsHoras]);
    setDatosGrafica([...datosGrafica]);
    let maximoY = 0;
    if (datos.length > 0) {
      maximoY = datos?.reduce((previous, current) => {
        return current.eTot > previous.eTot ? current : previous;
      });
    }

    setmaxYGrafica(Math.round((maximoY?.eTot + 100) / 100) * 100);
  }, [datos]);
  const labels = labelsGrafica;

  const data = {
    labels,
    datasets: [
      {
        label: "Potencia",
        data: datosGrafica,
        backgroundColor: "rgb(75, 138, 169)",
      },
    ],
  };

  return (
    <div className="w-100 flex justify-center pl-md-5 pr-md-5">
      <Bar height={tamanioGrafica()} options={options} data={data} />
    </div>
  );
};

export default BarchartComparativa;
